import { render } from "./DashboardWorking.vue?vue&type=template&id=126ddfb0"
import script from "./DashboardWorking.vue?vue&type=script&lang=js"
export * from "./DashboardWorking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__